/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { communicationV1MeetingMinutesNewCreate } from '../../__generated__/oazapfts-client';
import { GetAllCommunications } from '../queries/get-all-communications';
import { GetOneMeetingCommunication } from '../queries/get-one-meeting-communication';

export namespace CreateMeetingMinutes {
  export type Input = {
    title?: string;
    meetingId: string;
    content: string;
  };
  export type Output = { id: string };

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const auth = useAuth();
    const me = useMe();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const accessToken = await auth.getAccessToken();
        const result = await communicationV1MeetingMinutesNewCreate(
          {
            createMeetingMinutesViewMeetingMinutesInputRequest: {
              subject: input.title,
              email_id: input.meetingId,
              content: input.content,
            },
            xUserName: me.displayName,
            xUserEmail: me.email,
          },
          {
            baseUrl: `${appConfig.bffUrl}/plex`,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (result.status !== 201) {
          throw new Error('Fail to create meeting minutes');
        }

        return {
          id: result.data.uuid,
        };
      },
      async onSuccess(_, input) {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: GetAllCommunications.key({}),
          }),
          input.meetingId
            ? queryClient.invalidateQueries({
                queryKey: GetOneMeetingCommunication.key({
                  id: input.meetingId,
                }),
              })
            : undefined,
        ]);
      },
    });
  }
}
